import { render, staticRenderFns } from "./2025labourDay.vue?vue&type=template&id=2cbbb8cd&scoped=true&"
import script from "./2025labourDay.vue?vue&type=script&lang=js&"
export * from "./2025labourDay.vue?vue&type=script&lang=js&"
import style0 from "./2025labourDay.vue?vue&type=style&index=0&id=2cbbb8cd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cbbb8cd",
  null
  
)

export default component.exports